import React from 'react'
import DocumentTitle from 'react-document-title'
import { NavLink, Redirect, Route, Switch, useLocation, useParams } from 'react-router-dom'
import { PageTitle } from '@Root/components'
import { HandbookHub } from './Hub'
import { CognitoFields, CognitoOverview, CognitoSync } from './Cognito'
import { StudentCsvImport } from './Import'
import { ReferenceIndex, ReferenceTablePage } from './Reference'
import styles from './style.module.scss'
import '../../../components/page/PageNavLinks/style.scss'

const styleConfig = {
  navLinksStyles: {
    position: 'fixed',
    width: '100%',
    top: '115px',
    right: 0,
    zIndex: 10,
    padding: '0 10px',
  },
  pageTitle: {
    position: 'fixed',
    top: 0,
    zIndex: 10,
    marginTop: 50,
  },
}

const handbookTitle = pathname => {
  if (pathname.includes('/cognito/sync')) {
    return 'Application sync'
  }
  if (pathname.includes('/cognito/fields/')) {
    return 'Cognito fields'
  }
  if (pathname.includes('/cognito')) {
    return 'Cognito mapping'
  }
  if (pathname.includes('/import')) {
    return 'Student CSV import'
  }
  if (pathname.includes('/reference/')) {
    return 'Reference'
  }
  if (pathname.includes('/reference')) {
    return 'Reference'
  }
  return 'Handbook'
}

const CognitoFieldsRoute = () => {
  const { table } = useParams()
  return <CognitoFields table={table} />
}

export const HandbookPage = () => {
  const location = useLocation()
  const title = handbookTitle(location.pathname)

  return (
    <DocumentTitle title={`${title} - Handbook`}>
      <div className={styles.wrapper}>
        <PageTitle title={title} style={styleConfig.pageTitle} />
        <div style={{ ...styleConfig.navLinksStyles, width: '100%' }}>
          <div className='PageNavLinks'>
            <NavLink exact to='/home/handbook' activeClassName='active'>
              Overview
            </NavLink>
            <NavLink to='/home/handbook/cognito' activeClassName='active'>
              Cognito
            </NavLink>
            <NavLink to='/home/handbook/import/student-csv' activeClassName='active'>
              Student import
            </NavLink>
            <NavLink to='/home/handbook/reference' activeClassName='active'>
              Reference
            </NavLink>
          </div>
        </div>
        <div className={styles.content}>
          <Switch>
            <Route exact path='/home/handbook' component={HandbookHub} />
            <Route exact path='/home/handbook/cognito' component={CognitoOverview} />
            <Route exact path='/home/handbook/cognito/sync' component={CognitoSync} />
            <Route exact path='/home/handbook/cognito/fields/:table' component={CognitoFieldsRoute} />
            <Route exact path='/home/handbook/import/student-csv' component={StudentCsvImport} />
            <Route exact path='/home/handbook/reference' component={ReferenceIndex} />
            <Route exact path='/home/handbook/reference/:table' component={ReferenceTablePage} />
            <Redirect to='/home/handbook' />
          </Switch>
        </div>
      </div>
    </DocumentTitle>
  )
}
